import { useWorkspace } from "@/contexts/WorkspaceContext";
import { useCurrentUserRole } from "@/hooks/use-workspace-members";

export function useWorkspacePermissions() {
  const { currentWorkspaceId } = useWorkspace();
  const { data: role, isLoading } = useCurrentUserRole(currentWorkspaceId);

  return {
    role,
    isLoading,
    isOwner: role === "owner",
    isAdmin: role === "owner" || role === "admin",
    canEdit: role === "owner" || role === "admin" || role === "developer",
    canDelete: role === "owner" || role === "admin",
    isReadOnly: role === "member",
  };
}
